import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IAmazonAccountRecoveryRequest } from '../../../entity/interface/iEntitlements';
export interface IAmazonAccountRecoveryUseCase {
    execute(payload: IAmazonAccountRecoveryRequest, apiToken: string | { [key: string]: string }): Promise<any>;
}

export class AmazonAccountRecoveryUseCase implements IAmazonAccountRecoveryUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get amazonAccountRecoveryRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(payload: IAmazonAccountRecoveryRequest, apiToken: string | { [key: string]: string }): Promise<any> {
        return this.amazonAccountRecoveryRepository.amazonAccountRecovery(payload, apiToken);
    }
}
